import React from "react";
import { useFormikContext } from "formik";
import CommonMonthDayYearPicker from "../../../components/common/MonthDayYearPicker";

export default function MonthDayYearPicker({ name, label, disabled }) {
  const { values, setFieldValue, errors, touched, submitCount } = useFormikContext();
  const errorMessage = errors[name];
  const showError = (touched[name] || submitCount > 0) && errorMessage;

  return (
    <CommonMonthDayYearPicker
      value={values[name]}
      onChange={v => setFieldValue(name, v)}
      disabled={disabled}
      label={label}
      errorText={showError || ""}
    />
  );
}